import * as tslib_1 from "tslib";
import { AssetBase } from "@awayjs/core";
/**
 *
 */
var SamplerBase = (function (_super) {
    tslib_1.__extends(SamplerBase, _super);
    /**
     *
     */
    function SamplerBase(smooth, mipmap) {
        if (smooth === void 0) { smooth = false; }
        if (mipmap === void 0) { mipmap = false; }
        var _this = _super.call(this) || this;
        _this._smooth = smooth;
        _this._mipmap = mipmap;
        return _this;
    }
    Object.defineProperty(SamplerBase.prototype, "smooth", {
        /**
         *
         */
        get: function () {
            return this._smooth;
        },
        set: function (value) {
            if (this._smooth == value)
                return;
            this._smooth = value;
            //TODO: update dependencies
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SamplerBase.prototype, "mipmap", {
        /**
         *
         */
        get: function () {
            return this._mipmap;
        },
        set: function (value) {
            if (this._mipmap == value)
                return;
            this._mipmap = value;
            //TODO: update dependencies
        },
        enumerable: true,
        configurable: true
    });
    return SamplerBase;
}(AssetBase));
export { SamplerBase };



// WEBPACK FOOTER //
// ../dist/lib/image/SamplerBase.js